import { render } from "./ConfirmPassReset.vue?vue&type=template&id=6294037e&scoped=true"
import script from "./ConfirmPassReset.vue?vue&type=script&lang=js"
export * from "./ConfirmPassReset.vue?vue&type=script&lang=js"

import "./ConfirmPassReset.vue?vue&type=style&index=0&id=6294037e&scoped=true&lang=css"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6294037e"]])

export default __exports__